import React from "react";
import _ from "lodash";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import ListItemText from "@mui/material/ListItemText";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import Typography from "@mui/material/Typography";
import Badge from "@mui/material/Badge";
import StarIcon from "@mui/icons-material/Star";
import Flag from "react-world-flags";

import "./styles.scss";
import { Ranking } from "../../types/Game";

export type Props = {
  data: Array<Ranking>;
  order?: 'asc' |'desc' ;
  orderBy?: 'points' | 'timeStamp';
};

const RankingList = (props: Props) => {
  const data = _.orderBy(props.data, [props.orderBy ? props.orderBy  :"points"], [ props.order ? props.order: "desc"]);
  return (
    <List>
      {data.map((entry, index) => (
        <ListItem className="listItemGameOver" key={entry.position}>
          <Typography className="listRanking">#{index + 1}</Typography>
          <ListItemAvatar>
            <Avatar
              className="listAvatarImgRanking"
              alt={entry.name}
              src={entry.avatar}
            />
          </ListItemAvatar>
          <ListItemText
            className="listAvatarNameRanking"
            primary={entry.name}
          />
          <Flag className="rankingFlagGameOver" code={entry.countryCode} />
          <ListItemSecondaryAction>
            <Badge
              className="listBadgeOver"
              badgeContent={entry.points}
              color="primary"
              max={9999}
            >
              <StarIcon className="listIconOver" />
            </Badge>
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export default RankingList;
